import React from "react";
import { billingService } from "../../../Core/Api/services";
import TableSkeleton from "../../../Components/Table/TableSkeleton";
import { DbInvoiceExpenseInfos } from "../../../Core/Api/Types/db-invoice-expense-infos";
import BillingDetails from "../Details/billing-details";

function BillingCurrentMonth() {
  const [isLoading, setLoading] = React.useState(true);
  const [expenses, setExpenses] = React.useState<DbInvoiceExpenseInfos[]>([]);

  // Fetching data
  React.useEffect(() => {
    billingService.ListCurrentExpenses().then(function (response) {
      if (response.expenses) setExpenses(response.expenses);
      setLoading(false);
    });
  }, []);

  return <>{isLoading ? <TableSkeleton /> : <BillingDetails expenses={expenses} />}</>;
}

export default BillingCurrentMonth;
